/*
  Ralph Karouni - Bridal Guide page
  Only behaviour that isn't CSS-or-native: the Bridal Guides carousel bullet pagination.
  Desktop shows all cards (single dot); phone scroll-snaps one card at a time with one dot
  per card, the dots tracking the snapped card. Reveal-on-scroll = global rk-reveal.js.
  FAQ = native <details>. RTL-aware (mirrors scrollLeft sign).
*/
(function () {
  function initGuideCarousel(root) {
    var track = root.querySelector('[data-rk-guide-track]');
    var bullets = root.querySelector('[data-rk-guide-bullets]');
    if (!track || !bullets) return;
    var rtl = document.documentElement.dir === 'rtl';

    function cards() { return Array.prototype.slice.call(track.children); }
    function isScrollable() { return (track.scrollWidth - track.clientWidth) > 1; }
    // one dot per card when the track scrolls (mobile), a single dot when all 4 fit (desktop)
    function pageCount() { return isScrollable() ? cards().length : 1; }
    function cardOffset(card) { return card.offsetLeft - track.offsetLeft; }

    function build() {
      var pages = pageCount();
      bullets.innerHTML = '';
      bullets.style.display = 'flex';
      for (var i = 0; i < pages; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'rk-guide__bullet' + (i === 0 ? ' is-active' : '');
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        b.dataset.index = i;
        b.addEventListener('click', goTo);
        bullets.appendChild(b);
      }
      sync();
    }

    function goTo(e) {
      var i = parseInt(e.currentTarget.dataset.index, 10) || 0;
      var cs = cards();
      var target = cs[i] ? cardOffset(cs[i]) : 0;
      track.scrollTo({ left: rtl ? -target : target, behavior: 'smooth' });
    }

    function sync() {
      var dots = bullets.children;
      if (!dots.length) return;
      var pos = Math.abs(track.scrollLeft);
      var cs = cards();
      var best = 0, bestDist = Infinity;
      for (var i = 0; i < cs.length; i++) {
        var d = Math.abs(cardOffset(cs[i]) - pos);
        if (d < bestDist) { bestDist = d; best = i; }
      }
      if (best > dots.length - 1) best = dots.length - 1;
      for (var k = 0; k < dots.length; k++) {
        dots[k].classList.toggle('is-active', k === best);
      }
    }

    var raf = false;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = true;
      window.requestAnimationFrame(function () { raf = false; sync(); });
    }, { passive: true });

    window.addEventListener('resize', build, { passive: true });
    build();
  }

  /* FAQ: slide the native <details> panel open/closed (Graff slides; default <details> snaps).
     The chevron is driven by an .is-open class toggled in sync. Falls back to instant toggle
     under prefers-reduced-motion, and to plain <details> behaviour if JS never runs. */
  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  function slide(content, from, to, done) {
    content.style.overflow = 'hidden';
    content.style.height = from + 'px';
    content.offsetHeight; // force reflow
    content.style.transition = 'height 0.3s ease';
    content.style.height = to + 'px';
    var settled = false;
    function finish(e) {
      if (e && e.target !== content) return;
      if (settled) return;
      settled = true;
      content.removeEventListener('transitionend', finish);
      content.style.transition = '';
      content.style.height = '';
      content.style.overflow = '';
      done();
    }
    content.addEventListener('transitionend', finish);
    window.setTimeout(finish, 360);
  }
  function initFaq() {
    document.querySelectorAll('.rk-guide__faq-item').forEach(function (item) {
      if (item.dataset.rkFaq) return;
      item.dataset.rkFaq = '1';
      var summary = item.querySelector('.rk-guide__faq-q');
      var content = item.querySelector('.rk-guide__faq-a');
      if (!summary || !content) return;
      if (item.open) item.classList.add('is-open');
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (item.dataset.animating) return;
        if (item.open) {
          // close
          item.classList.remove('is-open');
          if (reduceMotion()) { item.open = false; return; }
          item.dataset.animating = '1';
          slide(content, content.scrollHeight, 0, function () { item.open = false; delete item.dataset.animating; });
        } else {
          // open
          item.open = true;
          item.classList.add('is-open');
          if (reduceMotion()) return;
          item.dataset.animating = '1';
          slide(content, 0, content.scrollHeight, function () { delete item.dataset.animating; });
        }
      });
    });
  }

  function init(root) {
    (root && root.querySelectorAll ? root : document).querySelectorAll('[data-rk-guide]').forEach(function (el) {
      if (el.dataset.rkGuideReady === '1') return; el.dataset.rkGuideReady = '1'; initGuideCarousel(el);
    });
    initFaq();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // theme editor re-render
  document.addEventListener('shopify:section:load', function (e) { init(e && e.target ? e.target : document); });
})();
